import { render, staticRenderFns } from "./Scales.vue?vue&type=template&id=49b116c9&scoped=true&"
import script from "./Scales.vue?vue&type=script&lang=js&"
export * from "./Scales.vue?vue&type=script&lang=js&"
import style0 from "./Scales.vue?vue&type=style&index=0&id=49b116c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b116c9",
  null
  
)

export default component.exports